import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { categories } from '../data/categories';
import { products } from '../data/products';
import SEO from '../common/SEO';
import NotFound from './NotFound';
import { motion } from 'framer-motion';
import ProductCategoryTabs from '../components/ProductCategoryTabs';
import SafeIcon from '../common/SafeIcon';

const CategoryPage = () => {
  const { kategorie } = useParams();
  const category = categories.find((item) => item.slug === kategorie);

  if (!category) return <NotFound />;

  const categoryProducts = products.filter((product) => product.kategorie === kategorie);

  return (
    <>
      <SEO
        title={category.seo.title}
        description={category.seo.description}
        path={`/produkty/${kategorie}`}
      />
      <div className="pt-20">
        <section className="bg-gray-900 py-24 text-white relative overflow-hidden text-center">
          <div className="absolute inset-0 bg-blue-600/10 mix-blend-overlay" />
          <div className="max-w-7xl mx-auto px-4 relative z-10">
            <ProductCategoryTabs />
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-5xl md:text-7xl font-bold italic tracking-tighter uppercase mb-6"
            >
              {category.nazev}
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed"
            >
              {category.perex}
            </motion.p>
          </div>
        </section>

        <section className="py-24 bg-white border-b border-gray-100">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {categoryProducts.map((product, index) => (
                <motion.div
                  key={product.slug}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="group bg-gray-50 rounded-[2.5rem] overflow-hidden border border-gray-100 hover:shadow-2xl transition-all duration-500"
                >
                  <div className="aspect-[340/148] overflow-hidden bg-gray-100 flex items-center justify-center">
                    {product.obrazky?.length ? (
                      <img
                        src={product.obrazekKarty || product.obrazky[0]}
                        alt={product.nazev}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      />
                    ) : (
                      <SafeIcon name="Zap" className="w-16 h-16 text-gray-300" />
                    )}
                  </div>
                  <div className="p-8 text-center md:text-left">
                    <h2 className="text-2xl font-bold italic uppercase tracking-tighter mb-4 text-gray-900">
                      {product.nazev}
                    </h2>
                    <p className="text-gray-600 text-sm mb-8 leading-relaxed h-20 overflow-hidden line-clamp-3">
                      {product.perex}
                    </p>
                    <Link
                      to={`/produkty/${kategorie}/${product.slug}`}
                      className="block text-center px-8 py-4 bg-blue-600 text-white rounded-xl font-bold uppercase tracking-widest text-xs hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20"
                    >
                      Detail produktu
                    </Link>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default CategoryPage;